<mat-form-field class="w-100" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [formControl]="control"
    (input)="this.onChange($event.target.value)"
    (blur)="this.onBlurEvent()"
    autocomplete="off"
    type="text"
    mask="separator.2"
    [thousandSeparator]="'.'"
    [decimalMarker]="','"
    separatorLimit="10000"
    prefix="R$ "
    [dropSpecialCharacters]="true"
  />
  <mat-error *ngIf="error">{{ error }}</mat-error>
</mat-form-field>
